// Лист снизу для телефона: SwipeableDrawer MUI.
// Появление translateY(100%) → 0 за 280 мс (cubic-bezier(0.32, 0.72, 0, 1)), закрытие 200 мс;
// свайп вниз дальше 30% высоты или быстрый — закрыть. Затемнение без blur: на слабых телефонах blur
// под движущимся листом роняет кадры. Esc и клик по затемнению закрывают (Modal).
import React from 'react';
import { Box, SwipeableDrawer } from '@mui/material';
import { REDUCED_MOTION } from '../../styles/tokens';
import { usePrefersReducedMotion } from './FadeIn';

export const SHEET_EASING = 'cubic-bezier(0.32, 0.72, 0, 1)';
const SHEET_ENTER_MS = 280;
const SHEET_EXIT_MS = 200;
const CLOSE_SHARE = 0.3;

const noop = () => {};

export default function BottomSheet({ open, onClose, onExited, labelledBy, ariaLabel, paperSx, children }) {
  const reduced = usePrefersReducedMotion();

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={noop}
      disableSwipeToOpen
      disableDiscovery
      disableBackdropTransition
      hysteresis={CLOSE_SHARE}
      transitionDuration={reduced ? 0 : { enter: SHEET_ENTER_MS, exit: SHEET_EXIT_MS }}
      SlideProps={{ easing: { enter: SHEET_EASING, exit: SHEET_EASING }, onExited }}
      // keepMounted: false — после закрытия содержимое размонтируется, как у Dialog (формы открываются заново)
      ModalProps={{ keepMounted: false, slotProps: { backdrop: { sx: { backgroundColor: 'rgba(0,0,0,0.6)' } } } }}
      PaperProps={{
        role: 'dialog',
        'aria-modal': true,
        'aria-labelledby': labelledBy,
        'aria-label': labelledBy ? undefined : ariaLabel,
        sx: {
          left: 0,
          right: 0,
          mx: 'auto',
          width: '100%',
          maxWidth: 720,
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          borderTop: '1px solid rgba(255,255,255,0.08)',
          backgroundImage: 'none',
          boxShadow: '0 -8px 30px rgba(0,0,0,0.4)',
          pb: 'env(safe-area-inset-bottom, 0px)',
          color: '#fff',
          [REDUCED_MOTION]: { transition: 'none !important' },
          ...paperSx,
        },
      }}
    >
      {/* Ручка: подсказка, что лист тянется вниз (тянуть можно за любое место) */}
      <Box aria-hidden="true" sx={{ flexShrink: 0, py: 1.25 }}>
        <Box sx={{ width: 36, height: 4, borderRadius: 2, backgroundColor: 'rgba(255,255,255,0.2)', mx: 'auto' }} />
      </Box>
      {children}
    </SwipeableDrawer>
  );
}
